import React, {useState} from 'react';
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";
import {safeFormatDateTime} from "../utils/safe-operations.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const EncounterListContent = ({ data, boName }) => {
    const navigate = navigateHook();
    const encounter_list = data?.encounter_list ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = encounter_list.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    return (
        <>
            <div className="mt-4 mb-6 table-div">
                <span className="table-title mb-2">Lista de abordagens {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>

                <table id="encounter-list-data" className="table report-table mt-2" sheet-name={'Lista de abordagens'}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[5%]">ID</th>
                            <th className="w-[10%]">{boName}</th>
                            <th className="w-[12%]">D/H inicial</th>
                            <th className="w-[10%]">Status</th>
                            <th className="w-[12%]">Abordado por</th>
                            <th className="w-[30%]">Justificativa</th>
                            <th className="w-[10%]">Indivíduos</th>
                            <th className="w-[10%]">Veículos</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !encounter_list?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? encounter_list.slice(0, limit) : encounter_list).map((element, index) => {
                            const url = `/encounter/form/${element.id}`;
                            const urlBo = `/bo/redirect/${element.bo?.replace('/', '-')}`;

                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-[5%]"><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.id ?? ""}</a></td>
                                        <td className="w-[10%]">{element.bo !== '-' ? (<a onClick={() => navigate(urlBo, true)} className={'inner-link'}>{element.bo ?? ""}</a>) : (element.bo)}</td>
                                        <td className="w-[12%]">{safeFormatDateTime(element.dt_start) ?? ""}</td>
                                        <td className="w-[10%]">{element.status ?? ""}</td>
                                        <td className="w-[12%]">{element.namewar ?? ""}</td>
                                        <td className="w-[30%]">{element.obs ?? ""}</td>
                                        <td className="w-[10%]">{element.individuals ?? 0}</td>
                                        <td className="w-[10%]">{element.vehicles ?? 0}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default EncounterListContent;
